@let moreThenOneEntity = moreThenOneEntitySg();
@let recordItems = recordItemsSg();
@let entityItems = entityItemsSg();
@let label = labelSg();
@let recordsLoading = recordsLoadingSg();
@let recordsError = recordsErrorSg();
@let partialValue = partialValueSg();

<div class="atn-referencer-switcher">
  <span class="atn-referencer-switcher__label"
    ><b>{{ label }}</b></span
  >

  <!-- Only display entities selector, when there is more then one entity -->
  @if (moreThenOneEntity) {
    <atn-ds-select-single
      [config]="{
        overlay: {
          minSearchCharacters: 1,
          entityName: 'Entity',
          hasSearch: true,
        },
      }"
      [value]="partialValue?.entityId"
      [items]="entityItems"
      (valueChange)="patchPartialValue({ entityId: $event })"
      [required]="requiredSg()"
    />
  }

  <atn-ds-select-single
    [config]="{
      overlay: {
        minSearchCharacters: 1,
        entityName: 'Record',
        hasSearch: true,
      },
    }"
    [items]="recordItems"
    [value]="partialValue?.recordId"
    [loading]="recordsLoading"
    [error]="recordsError"
    [required]="requiredSg()"
    (valueChange)="selectValueChangeHandler($event)"
    (refetch)="entityRefetchBtnClickHandler()"
  />
</div>

@if (showAddDialogSg()) {
  <atn-add-record-dialog />
}
